import { TextVariant, DeprecatedTextVariants, ValidTextTag } from './types';

const componentMap: { [key in TextVariant | DeprecatedTextVariants]?: string } = {
  inputLabel: 'label',
  inputLabelSmall: 'label',
  headingSmall: 'h3',
  headingMedium: 'h3',
  headingLarge: 'h2',
  headingXL: 'h1',
  headingXXL: 'h1',
  // Deprecated, but quickfix for A11y.
  button: 'button',
  buttonSmall: 'button',
};

export const getComponentOverride = (
  as: ValidTextTag | undefined,
  variant: TextVariant | DeprecatedTextVariants | undefined,
) => {
  if (as) return as;
  if (variant) return componentMap[variant];
  return undefined;
};
